export default function CarouselQuote({quote, name, location}) {
    return (
        <div className={'efs-landing-fromteachers-quote'}>
            <p>&ldquo;{quote}&rdquo;</p>
            <p>
                <span className={'efs-landing-fromteachers-quote-name'}>From {name}</span>
                <br/>
                <span className={'efs-landing-fromteachers-quote-location'}>{location}</span>
            </p>
        </div>
    )
}
